import { Loader2 } from "lucide-react";
import type { ComponentProps, ReactNode } from "react";

import { cn } from "helpers/cn";

import { Flex } from "./Flex";
import type { FlexProps } from "./Flex";

// Sizes mirror antd's Spin (14/20/32px) so swapped call sites keep their footprint.
const spinnerSizes = { small: 14, default: 20, large: 32 };

type SpinnerProps = Omit<ComponentProps<typeof Loader2>, "size"> & {
  size?: keyof typeof spinnerSizes;
};

const Spinner = ({ className, size, ...props }: SpinnerProps) => (
  <Loader2
    aria-label="Loading"
    className={cn("animate-spin text-brand", className)}
    data-slot="spinner"
    role="status"
    size={spinnerSizes[size ?? "default"]}
    {...props}
  />
);

type SpinnerOverlayProps = Omit<FlexProps, "children"> & {
  description?: ReactNode;
};

const SpinnerOverlay = ({ className, description, ...props }: SpinnerOverlayProps) => (
  <Flex
    align="center"
    className={cn("fixed inset-0 z-overlay bg-scrim", className)}
    data-slot="spinner-overlay"
    direction="col"
    gap={3}
    justify="center"
    {...props}
  >
    <Spinner size="large" />
    {description != null && <span className="text-body text-brand">{description}</span>}
  </Flex>
);

export { Spinner, SpinnerOverlay };
